export default __webpack_public_path__ + "static/media/Professional.a7024075.png";